




















































































































































































































import PreviewMenu from "@/views/dashboard/PreviewMenu.vue";
import PrintQrCode from "@/views/dashboard/PrintQrCode.vue";
import PDFInstead from "@/views/dashboard/PDFInstead.vue";
import EmailVerificationAlert from "@/components/EmailVerificationAlert.vue";
import Vue from "vue";

import { mapMutations } from "vuex";
import { LOGOUT } from "@/queries/user/mutation.graphql";
import {
  GET_MENU,
  GET_MENU_TYPE,
  GET_USER,
} from "@/queries/user/query.graphql";
import { apolloClient } from "@/apollo";
export default Vue.extend({
  data() {
    return {
      previewMenu: false,
      printQrCode: false,
      pdfInstead: false,
      user: null,
      visibleLeft: false,
      menuType: null,
    };
  },
  computed: {
    menuId() {
      return this.$store.getters["userModule/menuId"];
    },
  },
  apollo: {
    menuType: {
      query: GET_MENU_TYPE,
      update: (data) => data.Menu[0].menuType,
    },
    user: {
      query: GET_USER,
      update: (data) => data.User[0],
    },
  },
  components: {
    PreviewMenu,
    PrintQrCode,
    PDFInstead,
    EmailVerificationAlert,
  },
  methods: {
    logout() {
      this.$apollo
        .mutate({
          mutation: LOGOUT,
        })
        .then((data) => {
          if (data.data.logout.affected_rows) {
            this.$store.commit("authModule/logout");
          }
        })
        .catch((error) => {
          this.$store.commit("authModule/logout");
        });
    },
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.name === "menu-item") {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
      }
    },
  },
});
